"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsUtil = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const fs = tslib_1.__importStar(require("fs-extra"));
const uuid = tslib_1.__importStar(require("uuid"));
const yaml_1 = require("yaml");
const featureFlags_1 = require("../../common/featureFlags");
const globalVars_1 = require("../../common/globalVars");
const telemetry_1 = require("../../common/telemetry");
const common_1 = require("../../error/common");
const pathUtils_1 = require("./pathUtils");
class SettingsUtils {
    async readSettings(projectPath, ensureTrackingId = true) {
        let projectYamlPath;
        if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.GenerateConfigFiles)) {
            projectYamlPath = pathUtils_1.pathUtils.getAvailableYmlFilePath(projectPath);
        }
        else {
            projectYamlPath = pathUtils_1.pathUtils.getYmlFilePath(projectPath, "dev");
        }
        if (!projectYamlPath || !(await fs.pathExists(projectYamlPath))) {
            return (0, teamsfx_api_1.err)(new common_1.FileNotFoundError("SettingsUtils", projectYamlPath || "m365agents.*.yml"));
        }
        const yamlFileContent = await fs.readFile(projectYamlPath, "utf8");
        const appYaml = (0, yaml_1.parseDocument)(yamlFileContent);
        if (!appYaml.has("projectId") && ensureTrackingId) {
            const projectId = uuid.v4();
            const projectIdField = appYaml.createPair("projectId", uuid.v4());
            appYaml.add(projectIdField);
            await fs.writeFile(projectYamlPath, appYaml.toString()); // only write yaml file once instead of write yaml file after every command
            (0, telemetry_1.sendTelemetryEvent)(telemetry_1.Component.core, telemetry_1.TelemetryEvent.FillProjectId, {
                [telemetry_1.TelemetryProperty.ProjectId]: projectId,
            });
        }
        const projectSettings = {
            trackingId: appYaml.get("projectId"),
            version: appYaml.get("version"),
        };
        globalVars_1.globalVars.trackingId = projectSettings.trackingId; // set trackingId to globalVars
        return (0, teamsfx_api_1.ok)(projectSettings);
    }
    async writeSettings(projectPath, settings) {
        let projectYamlPath;
        if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.GenerateConfigFiles)) {
            projectYamlPath = pathUtils_1.pathUtils.getAvailableYmlFilePath(projectPath);
        }
        else {
            projectYamlPath = pathUtils_1.pathUtils.getYmlFilePath(projectPath, "dev");
        }
        if (!projectYamlPath || !(await fs.pathExists(projectYamlPath))) {
            return (0, teamsfx_api_1.err)(new common_1.FileNotFoundError("SettingsUtils", projectYamlPath || "m365agents.*.yml"));
        }
        const yamlFileContent = await fs.readFile(projectYamlPath, "utf8");
        const appYaml = (0, yaml_1.parseDocument)(yamlFileContent);
        appYaml.set("projectId", settings.trackingId);
        await fs.writeFile(projectYamlPath, appYaml.toString());
        return (0, teamsfx_api_1.ok)(projectYamlPath);
    }
}
exports.settingsUtil = new SettingsUtils();
//# sourceMappingURL=settingsUtil.js.map